<template>
  <div>
    <!-- 头部 -->
    <div class="temp-header">
      <div class="ml10">
        当前省份: <span class="primary">{{ provinceName }}</span>
      </div>
      <!-- 基础信息 -->
      <div class="basicInformation mt20">
        <div class="title mb10">基础信息</div>
        <div
          class="flex item-center flex-between mb20"
          style="font-size: 14px; gap: 30px"
        >
          <div>
            <span class="mr10" style="color: #5d5f64">申报单号</span>
            <span>{{ declareSn }}</span>
          </div>
          <div class="flex flex-between align-center">
            <span class="mr10" style="color: #5d5f64">商户名称</span>
            <span>{{ selectedStoreList.storeName }}</span>
          </div>
          <div>
            <span class="mr10" style="color: #5d5f64">商户编码</span>
            <span>{{ selectedStoreList.storeCode }}</span>
          </div>
          <div>
            <span class="mr10" style="color: #5d5f64">门店名称</span>
            <span>{{ selectedStoreList.shopName }}</span>
          </div>
        </div>
      </div>
    </div>
    <!-- 内容区域 -->
    <div class="flex flex-between">
      <!-- 商户门店列表 -->
      <div class="bg ocrResult p10">
        <div class="flex item-center flex-between">
          <div class="title" style="font-size: 14px">商户/门店列表</div>
          <div class="flex mb10" style="font-size: 12px; color: #666666">
            <div
              v-for="(v, i) in sort"
              :key="i"
              @click="sortList(v)"
              class="mr10 pointer"
              :class="{ primary: selectSort.prop === v.prop }"
            >
              {{ v.title }}
              <i class="el-icon-sort" v-if="selectSort.prop !== v.prop"></i>
              <i
                class="el-icon-sort-down"
                v-else-if="
                  selectSort.prop === v.prop && selectSort.order === 'asc'
                "
              ></i>
              <i
                class="el-icon-sort-up"
                v-else-if="
                  selectSort.prop === v.prop && selectSort.order === 'desc'
                "
              ></i>
            </div>
          </div>
        </div>
        <div>
          <el-input
            placeholder="搜索商户"
            suffix-icon="el-icon-search"
            v-model="searchMerchantsKeyword"
            @input="handleSearchInput"
            style="width: 100%"
            clearable
          >
          </el-input>
        </div>
        <div class="mt10 elCascaderBox">
           <el-cascader
            v-model="tagTitleValue"
            :options="tagTitleOptions"
            :props="{ expandTrigger: 'hover' }"
             style="width: 100%"
            @change="tagHandleChange"></el-cascader>
        </div>
        <div class="mt10 leftBox" style="height: calc(100vh - 300px)">
          <el-scrollbar style="height: 100%" class="page-component__scroll">
            <div class="leftStoreBox">
              <div
                class="storeBox"
                v-for="(item, index) in storeShopListNew"
                :key="index"
              >
                <div class="storeItem" @click.stop="selectRow(item, index)">
                  <div class="storeName">
                    <i class="el-icon-s-shop iconStore"></i>
                    <!-- <div class="flex item-center">
                      <div>{{ item.storeName }}</div>
                      <div class="ml20" style="color: #E50065; font-size: 12px;">
                        <span>{{item.declareCount}}单 </span>
                        <span>{{item.shopCount}}家</span>
                      </div>
                    </div> -->
                    <div style="width: 90%">
                      <span class="mr10">{{ item.storeName }}</span>
                      <span style="color: #e50065; font-size: 12px"
                        >{{ item.declareCount }}单
                      </span>
                      <span style="color: #e50065; font-size: 12px"
                        >{{ item.shopCount }}家</span
                      >
                    </div>
                  </div>
                  <div
                    @click.stop="changeRow(item, index)"
                    v-if="isShowStore == item.storeCode"
                  >
                    <i class="el-icon-success checkTrue" v-if="item.isShow"></i>
                    <div class="checkFalse" v-else></div>
                  </div>
                  <div v-else>
                    <i class="el-icon-arrow-right"></i>
                  </div>
                </div>
                <!-- 二级门店  -->
                <div class="shopBox mt10" v-if="isShowStore == item.storeCode">
                  <div
                    class="shopItem"
                    v-for="v in item.shopDataList"
                    :key="v.shopId"
                    @click="getCell(v)"
                  >
                    <div style="width: 90%">
                      <span class="mr10">{{ v.shopName }}</span>
                      <span style="color: #e50065; font-size: 12px"
                        >{{ v.declareCount }}单
                      </span>
                    </div>
                    <!-- <div class="flex item-center">
                      <div>{{ v.shopName }}</div>
                      <div class="ml20" style="color: #E50065; font-size: 12px;">
                        <span>{{v.declareCount}}单 </span>
                      </div>
                    </div> -->
                    <i class="el-icon-success checkTrue" v-if="v.isShow"></i>
                    <div class="checkFalse" v-else></div>
                  </div>
                </div>
              </div>
            </div>
          </el-scrollbar>
        </div>
        <div class="hm-pagination">
          <el-pagination
            background
            :total="total"
            small
            :pager-count="5"
            @current-change="paging"
            @size-change="handleSizeChange"
            :page-sizes="[10, 50, 100, 200]"
            layout="prev, pager, next"
            :current-page="currentPage"
            :page-size="pageSize"
          ></el-pagination>
        </div>
      </div>
      <!-- 配置标签 -->
      <div class="flex-1 bg ml10 p10" style="position: relative">
        <div class="flex item-center flex-between">
          <div class="title">配置标签</div>
          <div @click="addConfiguration" class="titleRight pointer">
            <i class="el-icon-s-tools" style="margin-right: 5px"></i
            >配置标签与模版
          </div>
        </div>
        <!-- 分组类型 -->
        <el-scrollbar style="height: 680px" class="page-component__scroll">
          <div
            class="shopGoodsNumBox mb20 pointer"
            v-for="(item, index) in labelGather"
            :key="index"
          >
            <div class="shopGoodsNumTitle" @click.stop="onChangeLabel(item)">
              
              <div>
                <i class="el-icon-arrow-down" v-if="item.isShow"></i>
                <i class="el-icon-arrow-right" v-else></i>
                <span style="margin-left: 5px">{{ item.itemText }}</span>
              </div>
              <div class="rightTagsBox">
                <div class="rightTags" v-for=" (label,ins) in item.tagNameList" :key="ins">{{label}}</div>
              </div>
            </div>
            <div class="shopLabelBox" v-if="item.isShow">
              <div
                class="mb10"
                v-for="info in item.labelList"
                :key="info.tagBasicInfoId"
              >
                <div class="custom-scrollbar">
                  <div class="shopLabelTitle">
                    {{ info.tagBasicInfoTagName }}
                  </div>
                  <div class="shopLabelContent">
                    <div
                      v-for="v in getDisplayList(info)"
                      :key="v.tagId"
                      :class="
                        item.optTagId == v.tagId
                          ? 'activeSelect shopLabel'
                          : 'shopLabel'
                      "
                      @click.stop="changeTags(item, v)"
                    >
                      <div>
                        <span style="margin-right: 5px">{{ v.tagName }}</span>
                        <span :class="getPassRateClass(v.passRate)">{{
                          formatPassRate(v.passRate)
                        }}</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  class="unfoldPackBox"
                  @click.stop="toggleExpand(info)"
                  v-if="info.runTemplateAllModelList.length > 5"
                >
                  <span>{{ info.isExpanded ? "收起" : "展开" }}</span>
                  <i
                    :class="[
                      { 'el-icon-arrow-down': !info.isExpanded },
                      { 'el-icon-arrow-up': info.isExpanded },
                    ]"
                  ></i>
                </div>
              </div>
              <div v-if="item.labelList.length == 0">暂无数据</div>
            </div>
          </div>
        </el-scrollbar>
        <div class="bottomFiexd">
          <div class="confirmFiexd" @click="committed">确认提交</div>
          <!-- <div class="cancelFiexd" @click="callOff">取消</div> -->
        </div>
      </div>
      <!-- 小票图片 -->
      <div class="flex-1 bg ml10 p10">
        <div class="flex item-center">
          <div class="title pointer" @click="resetImg">小票图片</div>
          <div class="flex flex-start item-center mb10 ml10">
            <el-tooltip
              class="item"
              effect="dark"
              content="向左旋转"
              placement="top-start"
            >
              <span
                @click="rotateImg(-90)"
                class="pointer hmicon icon-xiangzuoxuanzhuan mr10"
                style="font-size: 20px"
              ></span>
            </el-tooltip>
            <el-tooltip
              class="item"
              effect="dark"
              content="向右旋转"
              placement="top-start"
            >
              <span
                @click="rotateImg(90)"
                class="pointer hmicon icon-xiangyouxuanzhuan mr10"
                style="font-size: 20px"
              ></span>
            </el-tooltip>
          </div>
        </div>

        <div class="flex">
          <el-scrollbar style="height: 650px" class="page-component__scroll">
            <div
              :class="
                i == selectedImg
                  ? 'declareSnImg activeDeclareSnImg'
                  : 'declareSnImg'
              "
              v-for="(v, i) in srcList"
              :key="i"
              @click="handleClickImg(v, i)"
            >
              <el-image class="declareElImg" :src="v.declareImg"></el-image>
              <div
                class="declareSnImgNumTypeBox"
                v-if="v.typeList && v.typeList.length"
              >
                <div
                  class="declareSnImgNumType"
                  v-for="(info, index) in v.typeList"
                  :key="index"
                >
                  <div class="truncate-text">{{ info.fieldValue }}</div>
                  <div>
                    <span>{{ info.molecule }}</span>
                    <span style="color: #e50065">/{{ info.denominator }}</span>
                  </div>
                </div>
                <!-- <div class="declareSnImgNumType">
                  <div>金额</div>
                  <div>
                    <span>2</span>
                    <span>/4</span>
                  </div>
                </div> -->
              </div>
            </div>
          </el-scrollbar>
          <div class="crb-content">
            <div style="height: 500px">
              <div span="8" class="left" @mousewheel.prevent="rollImg">
                <img
                  :src="declareImg"
                  class="img"
                  ref="imgDiv"
                  @mousedown="move"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 申报单信息 -->
      <div class="flex-1 bg ml10 p10" style="width: 350px">
        <div class="title">小票基本信息</div>
        <el-scrollbar style="height: 700px" class="page-component__scroll">
          <div class="shopGoodsNumBox mb20">
            <div class="shopGoodsNumTitle">
              <span style="margin-left: 5px"></span>
            </div>
            <el-scrollbar style="height: 140px" class="page-component__scroll">
              <div class="rowBox">
                <div>门店名称</div>
                <div>{{ detailsSalesVolume.shopName }}</div>
              </div>
              <div class="rowBox">
                <div>小票号</div>
                <div>{{ detailsSalesVolume.receiptSn || "--" }}</div>
              </div>
              <div class="rowBox">
                <div>申报单号</div>
                <div>{{ detailsSalesVolume.declareSn }}</div>
              </div>
              <div class="rowBox">
                <div>小票时间</div>
                <div>{{ detailsSalesVolume.receiptDate || "--" }}</div>
              </div>
            </el-scrollbar>
          </div>

          <div class="title">申报信息标签匹配结果</div>
          <!-- <div style="min-height:200px;max-height:300px"> -->
          <!-- <el-scrollbar
            style="height: 300px; width: 100%"
            class="page-component__scroll"
          > -->
          <div class="informationLabel">
  <el-scrollbar style="height: 100%" class="page-component__scroll"> 
    <!-- 增加横向滚动容器 -->
    <div class="horizontal-scroll-container">
      <div class="flex" style="gap: 20px">
        <div class="cellWidth" v-for="(item, index) in labelMatchingResult" :key="index">
          <div class="mb20">{{ item.itemText }}</div>
          <div class="flex flex-column" style="gap: 20px">
            <div
              v-for="(info, indexx) in item.declareGoodsInfo"
              :key="indexx"
              class="cellBox"
            >
              <div>{{ info.fieldValue }}</div>
              <div v-if="item.itemText != '商品名称'">
                <i class="el-icon-circle-check" style="color:#2dc048" v-if="info.isCorrect"></i>
                <i class="el-icon-circle-close" style="color:#ed0000" v-else></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </el-scrollbar>
</div>

            <!-- <div class="mb10">
                <el-table
                ref="labelTable"
                :data="labelShopNameList"
                style="width: 100%"
                stripe
                size="small"
              >
                  <el-table-column align="center"  v-for="(col, index) in labelMatchingResult"
    :key="index">
                      <template slot="header">
                        <div>{{col.itemText}}</div>
                      </template>
                      <template>
                        <div class="cellDiv" v-for="(info, indx) in col.list" :key="indx">
                            <div>{{info.fieldValue}}</div>
                          <div>{{info.isCorrect}}</div>
                        </div>
                          
                      </template>
                    </el-table-column>
              </el-table>
          </div> -->
          <!-- </el-scrollbar> -->
          <!-- </div> -->
          <div class="title mt20">ocr识别结果</div>
          <div style="height: calc(100vh - 500px)" class="ocr">
            <el-scrollbar style="height: 100%" class="page-component__scroll">
              <div v-for="(v, i) in ocrResultList" :key="i" class="mb10">
                <div>{{ i + 1 }}. {{ v }}</div>
              </div>
            </el-scrollbar>
          </div>
        </el-scrollbar>
      </div>
    </div>
    <!-- <el-dialog
      title="配置标签模板"
      :close-on-click-modal="false"
      :visible.sync="dialogVisible"
      width="1000px"
      :before-close="cancel"
    > -->
    <!-- 抽屉形式的配置面板 -->
    <el-drawer
      title="配置标签模板"
      :visible.sync="dialogVisible"
      direction="ltr"
      :before-close="cancel"
      size="35%"
      :modal="false"
      :wrapperClosable="false"
      :append-to-body="true"
      custom-class="config-drawer"
    >
      <div class="drawer-content">
        <div class="title">配置模板</div>
        <div class="flex">
          <el-form
            v-if="dialogVisible"
            :model="ruleForm"
            :rules="rules"
            ref="ruleForm"
            :inline="false"
            label-width="130px"
          >
            <el-form-item label="模板名称" prop="templateName">
              <el-input
                style="width: 350px"
                maxlength="150"
                size="small"
                clearable
                class="mr10 ipt"
                v-model.trim="ruleForm.templateName"
                placeholder="请输入模板名称"
              ></el-input>
            </el-form-item>

            <el-form-item label="模板类型" prop="templateType">
              <el-select
                class="mr10"
                size="small"
                style="width: 350px"
                v-model="ruleForm.templateType"
                placeholder="请选择模板类型"
                @change="typeChange"
              >
                <el-option
                  v-for="item in allMerchant"
                  :key="item.itemValue"
                  :label="item.itemText"
                  :value="item.itemValue"
                >
                 <span style="float: left">{{ item.itemText }}</span>
                 <span style="color: #c5c6c7; font-size: 13px;margin-left:10px">{{ item.regularMatchDesc }}</span>
                </el-option>
              </el-select>
               <div style="color: #c5c6c7; font-size: 13px;">{{regularMatchDesc}}</div>
            </el-form-item>
            <el-form-item
              label="是否允许自动通过"
              prop="autoEnable"
              v-if="ruleForm.templateType === 'number'"
            >
              <el-switch
                size="mini"
                v-model="ruleForm.autoEnable"
                active-text="允许"
                inactive-text="禁止"
                active-color="#2fc348"
                inactive-color="#ff0000"
                active-value="yes"
                inactive-value="no"
              ></el-switch>
              <span class="form-red">数量匹配时是否允许自动通过</span>
            </el-form-item>
            <!-- <el-form-item label="预览结果" v-if="showResult">
              {{ preview }}
            </el-form-item> -->
            <div v-if="ruleForm.templateType !== 'receiptRepeat'">
              <div
                v-if="
                  ruleForm.templateType === 'number' ||
                  ruleForm.templateType === 'guiderName'
                "
              >
                <el-form-item label="数据所在行定位" prop="anchorType">
                  <div class="flex flex-column">
                    <div>
                      锚点：
                      <el-select
                        clearable
                        class="mr10"
                        size="small"
                        style="width: 150px"
                        v-model="ruleForm.anchorType"
                        placeholder="请选择锚点类型"
                      >
                        <el-option
                          label="条码所在行"
                          value="barcode"
                        ></el-option>
                        <el-option
                          label="商品名所在行"
                          value="goods"
                        ></el-option>
                        <el-option
                          label="条码或商品名所在行"
                          value="barcodeOrGoods"
                        ></el-option>
                      </el-select>
                    </div>
                    <div class="flex">
                      <span>相对位置：</span>
                      <span
                        class="flex flex-center item-center input-number-wrap"
                      >
                        <el-input-number
                          v-model="ruleForm.upwardOffsetRange"
                          placeholder="向上偏移范围"
                          size="small"
                          :min="-10"
                          :precision="0"
                          :controls="false"
                        ></el-input-number>
                        <span class="mx8">~</span>
                        <el-input-number
                          v-model="ruleForm.downwardOffsetRange"
                          placeholder="向下偏移范围"
                          size="small"
                          :min="-10"
                          :precision="0"
                          :controls="false"
                        ></el-input-number>
                      </span>
                    </div>
                  </div>
                </el-form-item>
              </div>
              <div v-else>
                <el-form-item
                  label="关键字类型"
                  prop="prefixType"
                  v-if="ruleForm.templateType == 'receiptSn'"
                >
                  <el-radio-group v-model="ruleForm.prefixType">
                    <el-radio :label="'notInclude'">关键字前缀</el-radio>
                    <el-radio :label="'include'">关键字开头</el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item
                  :label="
                    ruleForm.prefixType == 'include'
                      ? '以关键字开头'
                      : '关键字前缀'
                  "
                  prop="pasLabels"
                  v-if="ruleForm.templateType !== 'receiptSnDate'"
                >
                  <el-tag
                    :key="tag"
                    v-for="tag in ruleForm.pasLabels"
                    closable
                    :disable-transitions="false"
                    @close="handleClose(tag)"
                    >{{ tag }}</el-tag
                  >
                  <el-input
                    class="input-new-tag"
                    v-if="inputVisible"
                    v-model.trim="inputValue"
                    ref="saveTagInput"
                    size="small"
                    maxlength="10"
                    clearable
                    placeholder="请输入标签，在10个汉字以内"
                    @keyup.enter.native="handleInputConfirm"
                    @blur="handleInputConfirm"
                  ></el-input>
                  <el-button
                    v-else
                    class="button-new-tag"
                    size="small"
                    @click="showInput"
                    >+ 关键字</el-button
                  >
                  <span class="form-red">不输入则不限制</span>
                </el-form-item>
                <el-form-item
                  label="关键字后缀"
                  prop="pasLabelsLast"
                  v-if="ruleForm.templateType !== 'receiptSnDate'"
                >
                  <el-tag
                    :key="tag"
                    v-for="tag in ruleForm.pasLabelsLast"
                    closable
                    :disable-transitions="false"
                    @close="handleCloseLast(tag)"
                    >{{ tag }}</el-tag
                  >
                  <el-input
                    class="input-new-tag"
                    v-if="inputVisibleLast"
                    v-model.trim="inputValueLast"
                    ref="saveTagInputLast"
                    size="small"
                    maxlength="10"
                    clearable
                    placeholder="请输入关键字，在10个汉字以内"
                    @keyup.enter.native="handleInputConfirmLast"
                    @blur="handleInputConfirmLast"
                  ></el-input>
                  <el-button
                    v-else
                    class="button-new-tag"
                    size="small"
                    @click="showInputLast"
                    >+ 关键字</el-button
                  >
                  <span class="form-red">不输入则不限制</span>
                </el-form-item>
              </div>
              <div v-if="ruleForm.templateType === 'receiptSnDate'">
                <el-form-item label="从小票号第">
                  <div class="flex">
                    <el-form-item prop="minStrLength">
                      <el-input
                        type="number"
                        maxlength="25"
                        size="small"
                        clearable
                        class="mr10 ipt"
                        style="width: 156px"
                        v-model.trim="ruleForm.minStrLength"
                      ></el-input>
                    </el-form-item>
                    位到第
                    <el-form-item prop="maxStrLength">
                      <el-input
                        type="number"
                        maxlength="25"
                        size="small"
                        clearable
                        class="ml10 ipt"
                        style="width: 156px"
                        v-model.trim="ruleForm.maxStrLength"
                      ></el-input>
                    </el-form-item>
                    位
                  </div>
                </el-form-item>
              </div>
              <el-form-item
                label="字符长度"
                v-if="ruleForm.templateType != 'receiptSnDate'"
              >
                <div class="flex">
                  <el-form-item prop="minStrLength">
                    <el-input
                      type="number"
                      maxlength="25"
                      size="small"
                      clearable
                      class="mr10 ipt"
                      style="width: 156px"
                      v-model.trim="ruleForm.minStrLength"
                    ></el-input>
                  </el-form-item>
                  ~
                  <el-form-item prop="maxStrLength">
                    <el-input
                      type="number"
                      maxlength="25"
                      size="small"
                      clearable
                      class="ml10 ipt"
                      style="width: 156px"
                      v-model.trim="ruleForm.maxStrLength"
                    ></el-input>
                  </el-form-item>
                </div>
              </el-form-item>
              <el-form-item
                label="字符串格式"
                prop="strDemo"
                v-if="ruleForm.templateType != 'receiptSnDate'"
              >
                <el-input
                  v-if="
                    ruleForm.templateType !== 'receiptDate' ||
                    ruleForm.templateType !== 'receiptSnDate'
                  "
                  style="width: 350px"
                  maxlength="25"
                  size="small"
                  clearable
                  class="mr10 ipt"
                  v-model="ruleForm.strDemo"
                  :placeholder="placeholder"
                ></el-input>
                <el-select
                  v-else
                  clearable
                  class="mr10"
                  size="small"
                  style="width: 350px"
                  v-model="ruleForm.strDemo"
                  placeholder="请选择时间格式1"
                >
                  <el-option
                    label="yyyyMd (例：2021/5/1)"
                    value="yyyyMd"
                  ></el-option>
                  <el-option
                    label="yyyyMdd (例：2021/5/01)"
                    value="yyyyMdd"
                  ></el-option>
                  <el-option
                    label="yyyyMMd (例：2021/05/1)"
                    value="yyyyMMd"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item
                label="字符串格式"
                prop="strDemo"
                v-if="ruleForm.templateType === 'receiptSnDate'"
              >
                <el-select
                  clearable
                  class="mr10"
                  size="small"
                  style="width: 350px"
                  v-model="ruleForm.strDemo"
                  placeholder="请选择时间格式"
                >
                  <el-option
                    label="yyyyMd (例：2021/5/1)"
                    value="yyyyMd"
                  ></el-option>
                  <el-option
                    label="yyyyMdd (例：2021/5/01)"
                    value="yyyyMdd"
                  ></el-option>
                  <el-option
                    label="yyyyMMd (例：2021/05/1)"
                    value="yyyyMMd"
                  ></el-option>
                  <el-option
                    label="yyMMdd (例：21/05/01)"
                    value="yyMMdd"
                  ></el-option>
                  <el-option
                    label="yyMdd (例：21/5/01)"
                    value="yyMdd"
                  ></el-option>
                  <el-option label="yyMd (例：21/5/1)" value="yyMd"></el-option>
                  <el-option
                    label="yyyyMMdd (例：2021/05/01)"
                    value="yyyyMMdd"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="正则表达式">
                <template v-if="ruleForm.templateType === 'number'">
                  <div
                    class="flex item-center"
                    v-for="(item, ind) in regList"
                    :key="ind"
                  >
                    <el-input
                      v-model.trim="item.value"
                      class="mr10"
                      style="width: 350px"
                      size="small"
                      placeholder="请输入正则表达式"
                    ></el-input>
                    <el-button
                      v-if="ind === 0"
                      @click="handleRegAdd"
                      type="primary"
                      size="small"
                      >新增</el-button
                    >
                    <el-button
                      v-if="ind !== 0"
                      @click="handleRegDel(ind)"
                      type="primary"
                      size="small"
                      >删除</el-button
                    >
                  </div>
                </template>
                <el-input
                  v-else
                  v-model.trim="ruleForm.regularExtractRule"
                  style="width: 350px"
                  size="small"
                  placeholder="请输入正则表达式"
                ></el-input>
              </el-form-item>
              <el-form-item label="是否允许包含符号" prop="charEnable">
                <el-switch
                  size="mini"
                  v-model="ruleForm.charEnable"
                  active-text="允许"
                  inactive-text="禁止"
                  active-color="#2fc348"
                  inactive-color="#ff0000"
                  active-value="yes"
                  inactive-value="no"
                ></el-switch>
              </el-form-item>
            </div>
            <div v-else>
              <el-form-item label="转人工关键字" prop="keyRepeatList">
                <el-tag
                  :key="tag"
                  v-for="tag in ruleForm.keyRepeatList"
                  closable
                  :disable-transitions="false"
                  @close="handleCloseKey(tag)"
                  >{{ tag }}</el-tag
                >
                <el-input
                  class="input-new-tag"
                  v-if="inputVisibleKey"
                  v-model.trim="inputValueKey"
                  ref="saveTagInputKey"
                  size="small"
                  maxlength="10"
                  clearable
                  placeholder="请输入标签，在10个汉字以内"
                  @keyup.enter.native="handleInputConfirmKey"
                  @blur="handleInputConfirmKey"
                ></el-input>
                <el-button
                  v-else
                  class="button-new-tag"
                  size="small"
                  @click="showInputKey"
                  >+ 关键字</el-button
                >
              </el-form-item>
              <el-form-item label="去重规则" prop="repeatRule">
                <el-select
                  clearable
                  class="mr10"
                  size="small"
                  style="width: 350px"
                  v-model="ruleForm.repeatRule"
                  placeholder="去重规则"
                >
                  <el-option label="小票优先" value="receiptSn"></el-option>
                  <el-option
                    label="小票时间优先"
                    value="receiptDateStr"
                  ></el-option>
                  <el-option label="并行" value="both"></el-option>
                </el-select>
              </el-form-item>
            </div>

            <el-form-item label="小票示例">
              <el-upload
                class="upload flex"
                ref="eluploadMainPic"
                :limit="1"
                drag
                :data="{ fileDir: 'mall' }"
                :headers="{ 'X-Access-Token': $token }"
                :action="$uploadUrl"
                :onSuccess="uploadMainPicSucc"
                :beforeUpload="beforeUpload"
                :onProgress="uploading"
                :show-file-list="uploadShow"
                v-if="!ruleForm.templateImg"
              >
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">
                  将图片拖到此处，或
                  <em>点击上传</em>
                </div>
              </el-upload>
              <div class="priview" v-if="ruleForm.templateImg">
                <img :src="ruleForm.templateImg" alt="主图" />
                <div class="opreat-wrapper flex item-center flex-center">
                  <el-button type="text" @click="handleRemove">删除</el-button>
                </div>
              </div>
            </el-form-item>
            <el-form-item label="是否启用" prop="enableState">
              <el-switch
                size="mini"
                v-model="ruleForm.enableState"
                active-text="启用"
                inactive-text="禁用"
                active-color="#2fc348"
                inactive-color="#ff0000"
                active-value="yes"
                inactive-value="no"
              ></el-switch>
              <span class="form-red">关闭状态下直接启用系统默认规则</span>
            </el-form-item>
            <el-form-item label="模板描述" prop="description">
              <el-input
                style="width: 360px"
                type="textarea"
                v-model="ruleForm.description"
                placeholder="多行文本，请输入模板描述"
              ></el-input>
            </el-form-item>
          </el-form>
          <!-- <div class="flex-1 bg ocrResult p10" v-if="showResult">
            <div class="title">小票OCR识别结果</div>
            <div style="height: 900px" class="ocr">
              <el-scrollbar style="height: 100%" class="page-component__scroll">
                <div
                  v-for="(v, i) in ocrResultList"
                  :key="i"
                  class="mb10 pointer"
                >
                  <div>{{ i + 1 }}. {{ v }}</div>
                </div>
              </el-scrollbar>
            </div>
          </div> -->
        </div>
        <div class="title">配置标签</div>
        <div class="flex">
          <el-form
            v-if="dialogVisible"
            :model="ruleLableForm"
            :rules="labelRules"
            ref="labelRuleForm"
            :inline="false"
            label-width="130px"
          >
            <el-form-item label="标签组类型" prop="tagCategoryId">
              <el-select
                v-model="ruleLableForm.tagCategoryId"
                placeholder="请选择标签组类型"
                style="width: 350px"
                @change="changeTagCategory"
              >
                <el-option
                  v-for="item in tagGroupList"
                  :key="item.id"
                  :label="item.categoryName"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="所属分类" prop="id">
              <el-select
                v-model="ruleLableForm.id"
                placeholder="请选择所属分类"
                style="width: 350px"
              >
                <el-option
                  v-for="item in tagGroupListTwo"
                  :key="item.id"
                  :label="item.tagName"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="标签名称" prop="frontViewName">
              <el-input
                style="width: 350px"
                maxlength="150"
                size="small"
                clearable
                class="mr10 ipt"
                v-model.trim="ruleLableForm.frontViewName"
                placeholder="请输入标签名称"
              ></el-input>
            </el-form-item>
            <el-form-item label="标签说明" prop="dataDesc">
              <el-input
                style="width: 350px"
                maxlength="150"
                size="small"
                clearable
                class="mr10 ipt"
                v-model.trim="ruleLableForm.dataDesc"
                placeholder="请输入标签说明"
              ></el-input>
            </el-form-item>
          </el-form>
        </div>
        <div class="matchingResultBox" v-if="tagJoinTemplateId">
          <div>预估匹配结果</div>
          <div style="width: 85%">
            <div>匹配度 {{ tagPercentage }}%</div>
            <el-progress
              :text-inside="true"
              :stroke-width="12"
              :percentage="tagPercentage"
              status="success"
            ></el-progress>
          </div>
        </div>
        <span class="flex flex-center mt20 mb20">
          <el-button
            :disabled="!tagJoinTemplateId"
            @click="updateTemplateTagStatus()"
            size="small"
            type="primary"
          >
            确 认</el-button
          >
          <el-button size="small" @click="cancel">取 消</el-button>
          <el-button size="small" @click="submitForm()" type="primary">
            预估匹配度</el-button
          >
        </span>
      </div>
    </el-drawer>
    <!-- </el-drawer> -->
  </div>
</template>

<script>
import { unique } from "@/utils/utils";
import { Message, MessageBox, Loading } from "element-ui";
export default {
  data() {
    const strLengt = (rule, val, callback) => {
      /*if (!this.ruleForm.minStrLength || !this.ruleForm.maxStrLength) {
        return callback(new Error("请设置最小长度！"));
      }
      if (!this.ruleForm.maxStrLength) {
        return callback(new Error("请设置最大长度！"));
      }*/
      if (
        this.ruleForm.minStrLength !== "" &&
        this.ruleForm.maxStrLength !== ""
      ) {
        if (
          Number(this.ruleForm.minStrLength) >
          Number(this.ruleForm.maxStrLength)
        ) {
          /*let min = JSON.parse(JSON.stringify(this.ruleForm.minStrLength));
          let max = JSON.parse(JSON.stringify(this.ruleForm.maxStrLength));
          this.ruleForm.minStrLength = max;
          this.ruleForm.maxStrLength = min;*/
          return callback(new Error("长度最小值不能大于最大值！"));
        }
      }
      callback();
    };
    const minStrLengtIsNULL = (rule, val, callback) => {
      if (!this.ruleForm.minStrLength) {
        return callback(new Error("请设置最小长度！"));
      }
      callback();
    };
    const maxStrLengtIsNULL = (rule, val, callback) => {
      if (!this.ruleForm.maxStrLength) {
        return callback(new Error("请设置最大长度！"));
      }
      callback();
    };
    const validatoranchorType = (rule, val, callback) => {
      // if (this.ruleForm.upwardOffsetRange == "" || this.ruleForm.upwardOffsetRange == undefined) {
      //   return callback(new Error("请输入向上偏移范围"));
      // }
      // if (this.ruleForm.downwardOffsetRange == "" || this.ruleForm.downwardOffsetRange == undefined) {
      //   return callback(new Error("请输入向下偏移范围"));
      // }
      // callback();
      const upward = this.ruleForm.upwardOffsetRange;
      const downward = this.ruleForm.downwardOffsetRange;

      // 检查是否都为数字
      if (upward === undefined || downward === undefined) {
        return callback(new Error("请输入完整的偏移范围"));
      }

      const isUpwardNegative = upward < 0;
      const isDownwardNegative = downward < 0;

      // 判断两个都为负数的情况（不合法）
      if (isUpwardNegative && isDownwardNegative) {
        return callback(new Error("不允许两个偏移量同时为负数"));
      }

      // 如果一正一负，则判断正数的绝对值是否大于负数的绝对值
      if (isUpwardNegative && !isDownwardNegative) {
        if (Math.abs(upward) >= downward) {
          return callback(
            new Error(
              "向下偏移量（正数）的绝对值必须大于向上偏移量（负数）的绝对值"
            )
          );
        }
      } else if (!isUpwardNegative && isDownwardNegative) {
        if (Math.abs(downward) >= upward) {
          return callback(
            new Error(
              "向上偏移量（正数）的绝对值必须大于向下偏移量（负数）的绝对值"
            )
          );
        }
      }

      callback();
    };
    const validatorRelativeType = (rule, val, callback) => {
      if (
        this.ruleForm.relativeType === "keyWord" &&
        this.ruleForm.keyWord == ""
      ) {
        return callback(new Error("请输入关键字！"));
      } else {
        if (this.ruleForm.rowSeq == "") {
          return callback(new Error("请选择行相对位置！"));
        }
        if (this.ruleForm.numIndex == "") {
          return callback(new Error("请输入定位数字位置!"));
        }
      }
      callback();
    };
    const validatorRegularExtractRule = (rule, val, callback) => {
      if (this.ruleForm.templateType === "number") {
        for (let item of this.regList) {
          if (!item.value) {
            return callback(new Error("请输入正则表达式"));
          }
        }
      } else {
        if (!val) {
          return callback(new Error("请输入正则表达式"));
        }
      }
      callback();
    };
    return {
      sort: [
        {
          title: "按门店数量排序",
          order: "",
          prop: "shopId",
        },
        {
          title: "按申报单量排序",
          order: "",
          prop: "declareSn",
        },
      ],
      selectSort: {
        title: "",
        order: "",
        prop: ":",
      },
      provinceName: "",
      searchMerchantsKeyword: "",
      tagTitleValue:['all'],
      tagTitleOptions:[],
      isShowStore: "",
      prevStoreCode: null,
      rotateDeg: 0,
      zoom: 100,
      ocrResultList: [],
      detailsSalesVolume: {}, //小票所有信息
      selectedShopsList: [], //选择的门店列表
      selectedStoreList: {}, //选择的商户
      currentPage: 1,
      pageSize: 10,
      total: 0,
      storeShopList: [],
      storeShopListNew: [],
      filteredStoreShopList: [],
      srcList: [],
      selectedImg: 0,
      declareSn: "",
      declareImg: "",
      fieldType: "", //模板类型
      // labelList: [],
      labelGather: [], //配置标签模版
      labelGatherOne: [], //配置标签模版初始数据
      labelMatchingResult: [], //申报信息匹配结果
      labelShopNameList: [],
      tagId: "",
      searchTimer: null,
      // 模板弹框配置
      dialogVisible: false,
      allMerchant: [],
      regularMatchDesc:'',
      ruleForm: {
        repeatRule: "",
        charEnable: "no",
        enableState: "no",
        autoEnable: "no",
        keyPrefix: "",
        keySuffix: "",
        strDemo: "",
        maxStrLength: "",
        minStrLength: "",
        templateType: "receiptDate",
        pasLabels: [],
        pasLabelsLast: [],
        keyRepeatList: [],
        keyRepeat: "",
        templateName: "",
        anchorType: "",
        relativePosition: "",
        relativeType: "",
        keyWord: "",
        rowSeq: "",
        numIndex: "",
        templateImg: "",
        description: "",
        prefixType: "notInclude",
        regularExtractRule: "",
        upwardOffsetRange: undefined,
        downwardOffsetRange: undefined,
      },
      rules: {
        templateName: {
          required: true,
          message: "请输入模板名称",
          trigger: "change",
        },
        templateType: {
          required: true,
          message: "请选择模板类型",
          trigger: "change",
        },
        repeatRule: {
          required: true,
          message: "请选择去重规则",
          trigger: "change",
        },
        maxStrLength: [
          {
            validator: strLengt,
          },
          {
            validator: maxStrLengtIsNULL,
          },
        ],
        minStrLength: [
          {
            validator: strLengt,
          },
          {
            validator: minStrLengtIsNULL,
          },
        ],
        anchorType: [
          {
            required: true,
            message: "请选择锚点类型",
            trigger: "change",
          },
          {
            required: true,
            validator: validatoranchorType,
          },
        ],
        relativeType: [
          {
            required: true,
            message: "请选择相对锚点位置类型",
            trigger: "change",
          },
          {
            required: true,
            validator: validatorRelativeType,
          },
        ],
        templateImg: {
          required: true,
          message: "请输入小票示例",
          trigger: "change",
        },
        enableState: {
          required: true,
        },
        regularExtractRule: {
          required: true,
          trigger: "change",
          validator: validatorRegularExtractRule,
        },
      },
      showResult: false,
      inputValue: "",
      inputVisible: false,
      inputVisibleLast: false,
      inputValueLast: "",
      regList: [{ key: 1, value: "" }],
      inputVisibleKey: false,
      inputValueKey: "",
      uploadShow: true,
      placeholder: "例如：2020-12-01 19:00:00",
      type: "add",
      // 标签配置
      ruleLableForm: {
        tagCategoryId: "",
        id: "",
        wecomTagMappingMode: "no",
        showGroup: "yes",
        showType: "pave",
        selectMode: "single",
        frontViewName: "",
        dataColor: "#ED7B2F",
        dataDesc: "",
        tenantId: "",
      },
      labelRules: {
        tagCategoryId: {
          required: true,
          message: "请选择标签组类型",
          trigger: "change",
        },
        id: {
          required: true,
          message: "请选择所属分类",
          trigger: "change",
        },
        frontViewName: {
          required: true,
          message: "请输入标签名称",
          trigger: "blur",
        },
      },
      tagGroupList: [],
      tagGroupListTwo: [],
      sysReceiptOcrTemplateModel: "",
      isExpanded: false, // 控制是否展开
      tagJoinTemplateId: "", //跑测 模板id
      tagPercentage: 0, //匹配的
    };
  },
  watch: {
    // isShowStore(newVal, oldVal) {
    //   if (oldVal && newVal !== oldVal) {
    //     this.handlePrevStore(oldVal); // 清除上一次的 isShow
    //     // this.handleCurrentStore(newVal); // 设置当前第一个子项为 true
    //     this.prevStoreCode = newVal; // 更新 prevStoreCode
    //   }
    // },
    // storeShopList: {
    //   handler(newVal) {
    //     this.syncParentWithChildren();
    //   },
    //   deep: true,
    // },
  },
  computed: {
    // 获取所有 optTagId 有值的集合
    validOptTagIds() {
      return this.labelGather
        .filter((item) => item.optTagId) // 过滤出 optTagId 有值的项
        .map((item) => item.optTagId); // 只保留 optTagId 形成数组
    },
    // filteredLabelList() {
    //   if (this.isExpanded) {
    //     return this.labelList; // 展开时返回全部数据
    //   } else {
    //     return this.labelList.filter(v => v.passRate >= 0.7); // 默认只展示 passRate >= 70%
    //   }
    // }
  },
  created() {
    this.provinceName = this.$route.query.provinceName;
    if (this.$route.query.storeProvince) {
      this.queryStoreShopList();
    }
    this.queryGetEnumData();
    // this.initData();
  },
  activated() {
    // this.provinceName = this.$route.query.provinceName;
    // if (this.$route.query.storeProvince) {
    //   this.queryStoreShopList();
    // }
    // this.queryGetEnumData();
  },
  mounted() {
    // this.initData();
  },
  methods: {
    format(percentage) {
      return percentage === 100 ? "满" : `${percentage}%`;
    },
    sortList(selectSort) {
      switch (selectSort.order) {
        case "asc":
          selectSort.order = "desc";
          break;
        case "desc":
          selectSort.order = "asc";
          break;
        default:
          selectSort.order = "desc";
      }
      this.selectSort = selectSort;
      this.sortFun();
    },
    sortFun() {
      const { prop, order } = this.selectSort;

      if (!this.storeShopList || !Array.isArray(this.storeShopList)) return;

      // 深拷贝一份数据用于排序，避免直接修改原始数据
      let sortedList = [];
      if (this.searchMerchantsKeyword) {
        sortedList = [...this.filteredStoreShopList];
      } else {
        sortedList = [...this.storeShopList];
      }

      // 自定义排序函数
      sortedList.sort((a, b) => {
        let valA, valB;

        if (prop === "shopId") {
          valA = a.shopCount;
          valB = b.shopCount;
        } else if (prop === "declareSn") {
          valA = a.declareCount;
          valB = b.declareCount;
        } else {
          // 默认排序逻辑：先按 declareCount 降序，再按 declareSn 降序
          if (b.declareCount !== a.declareCount) {
            return b.declareCount - a.declareCount;
          }
          return (b.declareSn || "")
            .toString()
            .localeCompare((a.declareSn || "").toString());
        }

        // 如果是升序
        if (order === "asc") {
          return valA - valB;
        }

        // 如果是降序
        if (order === "desc") {
          return valB - valA;
        }

        return 0;
      });

      // 更新原始数据或赋值给一个新变量
      // this.storeShopList = sortedList;
      if (this.searchMerchantsKeyword) {
        this.filteredStoreShopList = sortedList;
      } else {
        this.storeShopList = sortedList;
      }
      this.getStoreShopList();
      console.log(this.selectSort, "当前排序条件");
    },
    getDisplayList(info) {
      const list =
        info && Array.isArray(info.runTemplateAllModelList)
          ? info.runTemplateAllModelList
          : [];

      if (!list.length) return [];

      const filteredList = list.filter((v) => v.passRate >= 0.7);

      if (!filteredList.length && !(info && info.isExpanded)) {
        return list.slice(0, 5);
      }

      if (info && info.isExpanded) {
        return list;
      }

      return filteredList;
    },
    toggleExpand(info) {
      info.isExpanded = !info.isExpanded;
    },
    //   toggleExpand() {
    //   this.isExpanded = !this.isExpanded;
    // },
    onChangeLabel(item) {
      item.isShow = !item.isShow;
      if (item.isShow) {
        this.fieldType = item.itemValue;
        this.runTemplateAllByDeclareSn();
      }
    },
    handleDrawerClose(done) {
      this.$confirm("确认关闭？")
        .then((_) => {
          done();
        })
        .catch((_) => {});
    },
    formatPassRate(rate) {
      return `${(rate * 100).toFixed(0)}%`;
    },
    getPassRateClass(rate) {
      return rate >= 0.7 ? "green-text" : "red-text";
    },
    handleClick(tab, event) {
      console.log(this.fieldType, "****54545----");
      this.runTemplateAllByDeclareSn();
    },
    initData() {
      this.storeShopListNew.forEach((item, index) => {
        // 使用 $set 确保响应式更新
        this.$set(item, "isShow", false);

        // 只有当 item.shopDataList 存在并且是一个非空数组时才进行遍历
        if (Array.isArray(item.shopDataList) && item.shopDataList.length > 0) {
          item.shopDataList.forEach((item2, index2) => {
            // if (index === 0 && index2 === 0) {
            //   this.$set(item2, "isShow", true);
            // this.isShowStore = item.storeCode;
            // } else {
            //   this.$set(item2, "isShow", false);
            // }

            if (this.isShowStore == item.storeCode) {
              if (index2 === 0) {
                this.$set(item2, "isShow", true);
              }
            }
          });
        }
      });

      this.syncParentWithChildren();
    },
    selectRow(item, index) {
      // this.isShowStore = item.storeCode;
      this.queryStoreShopListByStoreCode(item.storeCode,item.storeName);
    },
    changeRow(item, index) {
      const currentState = item.isShow;
      // 设置当前一级门店的 isShow，并同步到子项
      this.$set(this.storeShopListNew[index], "isShow", !currentState);
      if (item.shopDataList && item.shopDataList.length > 0) {
        item.shopDataList.forEach((v) => {
          this.$set(v, "isShow", !currentState);
        });
      }
      this.syncParentWithChildren();
    },
    getCell(v) {
      v.isShow = !v.isShow;
      // 同步更新一级门店的 isShow
      this.syncParentWithChildren();
    },
    // 同步一级门店与二级门店的状态
    syncParentWithChildren() {
      this.selectedShopsList = []; // 清空旧数据
      this.selectedStoreList = {};

      this.storeShopListNew.forEach((store) => {
        if (store.shopDataList && store.shopDataList.length > 0) {
          const allChecked = store.shopDataList.every((v) => v.isShow === true);
          const someUnchecked = store.shopDataList.some(
            (v) => v.isShow === false
          );

          if (store.storeCode == this.isShowStore) {
            this.selectedStoreList = {
              storeCode: store.storeCode,
              storeName: store.storeName,
            };
          }

          if (allChecked) {
            store.isShow = true;
          } else if (someUnchecked) {
            store.isShow = false;
          }

          const selectedShops = store.shopDataList.filter(
            (v) => v.isShow === true
          );

          this.selectedShopsList.push(...selectedShops);
        }
      });
      console.log(this.selectedShopsList, this.selectedStoreList, 99999);

      if (this.selectedShopsList.length) {
        this.selectedStoreList.shopName = this.selectedShopsList[0].shopName;
        this.queryDeclareByShopIdsList();
        this.queryStoreTagList()
      } else {
        this.$message.warning("无门店数据");
      }
    },
    handlePrevStore(storeCode) {
      console.log("清除了吗");
      const prevStore = this.storeShopListNew.find(
        (store) => store.storeCode === storeCode
      );
      if (prevStore && prevStore.shopDataList) {
        prevStore.shopDataList.forEach((v) => {
          v.isShow = false;
        });
      }
    },
    // 设置当前门店的第一个子项 isShow 为 true
    handleCurrentStore(storeCode) {
      const currentStore = this.storeShopListNew.find(
        (store) => store.storeCode === storeCode
      );
      if (
        currentStore &&
        currentStore.shopDataList &&
        currentStore.shopDataList.length > 0
      ) {
        currentStore.shopDataList[0].isShow = true;
        this.syncParentWithChildren();
      }
    },
    // 选择小票
    handleClickImg(v, i) {
      this.declareSn = v.declareSn;
      this.selectedImg = i;
      const shop = this.selectedShopsList.find(
        (item) => item.shopId == v.shopId
      );
      this.selectedStoreList.shopName = shop ? shop.shopName : "";
      this.detailsSalesVolumeList();
      this.getLabelMatchingResult();
    },
    // 旋转图片
    rotateImg(deg) {
      this.rotateDeg = this.rotateDeg + deg;
      this.$refs.imgDiv.style.transform = `scale(${this.zoom / 100}) rotate(${
        this.rotateDeg
      }deg)`;
    },
    // 缩放图片
    rollImg(event) {
      /* 获取当前页面的缩放比 若未设置zoom缩放比，则为默认100%，即1，原图大小 */
      this.zoom = parseInt(this.$refs.imgDiv.style.zoom) || 100;
      /* event.wheelDelta 获取滚轮滚动值并将滚动值叠加给缩放比zoom wheelDelta统一为±120，其中正数表示为向上滚动，负数表示向下滚动 */

      this.zoom += event.wheelDelta / 12;
      /* 最小范围 和 最大范围 的图片缩放尺度 */
      if (this.zoom >= 80 && this.zoom < 1000) {
        this.$refs.imgDiv.style.zoom = this.zoom + "%";
      }
      this.$refs.imgDiv.style.transform = `scale(${this.zoom / 100}) rotate(${
        this.rotateDeg
      }deg)`;
      return false;
    },
    // 拖动图片
    move(e) {
      e.preventDefault();
      // 获取元素
      var left = document.querySelector(".left");
      var img = document.querySelector(".img");
      var x = e.pageX - img.offsetLeft;
      var y = e.pageY - img.offsetTop;
      // 添加鼠标移动事件
      left.addEventListener("mousemove", move);
      function move(e) {
        img.style.left = e.pageX - x + "px";
        img.style.top = e.pageY - y + "px";
      }
      // 添加鼠标抬起事件，鼠标抬起，将事件移除
      img.addEventListener("mouseup", function () {
        left.removeEventListener("mousemove", move);
      });
      // 鼠标离开父级元素，把事件移除
      left.addEventListener("mouseout", function () {
        left.removeEventListener("mousemove", move);
      });
    },
    // 图片恢复初始状态
    resetImg() {
      let img = this.$refs.imgDiv;
      if (img) {
        img.style.left = "0px";
        img.style.top = "0px";
        img.style.zoom = "100%";
        this.rotateDeg = 0; // 旋转角度
        this.zoom = 100;
        img.style.transform = "none";
      }
    },
    // 搜索
   handleSearchInput() {
    if (this.searchTimer) {
      clearTimeout(this.searchTimer);
    }

    this.searchTimer = setTimeout(() => {
      const keyword = this.searchMerchantsKeyword.toLowerCase();
      let sortedList = [...this.storeShopList];

      if (!this.searchMerchantsKeyword) {
        this.getStoreShopList();
        return;
      }

      this.filteredStoreShopList = sortedList.filter((item) => {
        const storeName = item.storeName ? item.storeName.toLowerCase() : '';
        return storeName.includes(keyword);
      });

      this.sortFun();
    }, 500);
  },
  // 配置选择 (未配置 已配置) 
    tagHandleChange(e) {
      this.queryStoreShopList()
      // this.queryStoreShopListByStoreCode(this.selectedStoreList.storeCode,this.selectedStoreList.storeName)
      // console.log(e,this.tagTitleValue,'小孩能做了选择了');
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      // this.queryStoreShopList();
      this.getStoreShopList();
    },
    paging(page) {
      this.currentPage = page;
      // this.queryStoreShopList();
      this.getStoreShopList();
    },
    // 获取标签切换类型
    async queryGetEnumData() {
      const { result } = await this.$store.dispatch("declareTemplateType");
      if (result && result.length) {
        this.labelGather = result.map((item, index) => ({
          ...item,
          labelList: [],
          optTagId: "",
          isShow: index === 0, // 第一项为 true，其余为 false
        }));
        this.fieldType = result[0].itemValue;
        this.allMerchant = result;
         this.allMerchant.forEach(item => {
            try {
              // 将 description 字符串解析为对象
              const descriptionObj = JSON.parse(item.description);
              // 判断解析后的对象中是否有 regularMatchDesc 属性
              if (descriptionObj && descriptionObj.regularMatchDesc) {
                item.regularMatchDesc = descriptionObj.regularMatchDesc;
              } else {
                item.regularMatchDesc = '';
              }
              if(this.ruleForm.templateType === item.itemValue) {
                  this.regularMatchDesc = item.regularMatchDesc;
                }
            } catch (e) {
              // 如果解析失败，则将 regularMatchDesc 设为空字符串
              item.regularMatchDesc = '';
            }
          });
        this.labelGatherOne = JSON.parse(JSON.stringify(this.labelGather));
        this.tagTitleOptions = []
        // this.labelMatchingResult = result;
            result.forEach(item => {
            const { description } = item;
            this.tagTitleOptions.push({
              label: item.itemText,
              value: item.itemValue,
              children: [{
              value: 'unconfigured',
              label: '未配置'
            }, {
              value: 'configured',
              label: '已配置'
            }]
            });
            // 检查 description 是否存在且是字符串
            if (typeof description !== 'string' || !description.trim()) {
              console.warn(`Item ${item.id} has invalid or empty description`, item);
              return;
            }
            try {
              const parsedDesc = JSON.parse(description);

              // 确保解析后的对象有 showType === "details"
              if (parsedDesc && parsedDesc.showType === "details") {
                this.labelMatchingResult.push(item);
              }
            } catch (error) {
              console.error(`Invalid JSON in description for item ${item.id}:`, description);
              console.error(`Parse error:`, error.message);
            }
          });
         this.tagTitleOptions.unshift({
          value: 'all',
          label: '全部'
        });
      }
      console.log(this.labelGather, "先完成第一步");
    },
    async getStoreShopList() {
      //分页处理
      let sortedList = [];
      if (this.searchMerchantsKeyword) {
        sortedList = [...this.filteredStoreShopList];
      } else {
        sortedList = [...this.storeShopList];
      }
      // 标签当前分页的数据
      const totalPages = Math.ceil(sortedList.length / this.pageSize);
      if (this.currentPage > totalPages) {
        this.currentPage = totalPages || 1; // 确保至少为第一页
      }
      this.total = sortedList.length;
      // console.log("getStoreShopList", this.storeShopList.length,this.total);
      // 获取当前页的第一项
      const startIndex = (this.currentPage - 1) * this.pageSize;
      const endIndex = this.currentPage * this.pageSize;
      this.storeShopListNew = sortedList.slice(startIndex, endIndex);
      console.log("startIndex", startIndex);
      console.log("endIndex", endIndex);
      console.log("根据假分页处理的数据", this.storeShopListNew);
      // this.$nextTick(() => {
      this.storeShopListNew = sortedList.slice(startIndex, endIndex);
      // });
      if (this.storeShopListNew.length) {
        let code = this.storeShopListNew[0].storeCode;
        let storeName = this.storeShopListNew[0].storeName;
        this.queryStoreShopListByStoreCode(code, storeName);
      }
      this.$forceUpdate();
    },
    // 根据省获取商户
    async queryStoreShopList() {
      let params = {
        // pageSize: this.pageSize,
        // pageNo: this.currentPage,
        // storeName: this.searchMerchantsKeyword,
        storeProvince: this.$route.query.storeProvince,
      };
      const { result } = await this.$store.dispatch(
        "queryStoreShopList",
        params
      );
      if(this.tagTitleValue.length > 1) {
        let v1 = this.tagTitleValue[1]
        if(v1 == 'unconfigured') {
          this.storeShopList = result.filter(item => item.unConfigCount !== 0);
        }else {
          this.storeShopList = result;
        }
      }else {
        this.storeShopList = result;
      }
      this.sortFun();
      // this.getStoreShopList()
      // this.total = total;
      // let code = records[0].storeCode;
      // this.queryStoreShopListByStoreCode(code);
    },
    // 根据商户获取门店
    async queryStoreShopListByStoreCode(code, name) {
      if (this.isShowStore) {
        this.handlePrevStore(this.isShowStore);
      }
      let value1 = ''
      let value2 = ''
      if(this.tagTitleValue.length > 1) {
        value1 = this.tagTitleValue[0]
        value2 = this.tagTitleValue[1]
      }else {
        value1 = ''
        value2 = ''
      }
      let params = {
        storeCode: code,
        fieldType:value1,
        tag:value2
      };
      const { result } = await this.$store.dispatch(
        "queryStoreShopListByStoreCode",
        params
      );
      this.storeShopListNew = this.storeShopListNew.map((store) =>
        store.storeCode === code
          ? { ...store, shopDataList: result || [] }
          : store
      );
      if (result.length > 0) {
        this.isShowStore = code;
        this.initData();
      } else {
        this.$message.warning(`${name}没有门店`);
        this.resetData();
      }
    },
    // 根据门店获取ocr小票列表
    async queryDeclareByShopIdsList() {
      let params = {
        shopIds: this.selectedShopsList.map((v) => v.shopId),
      };

      const { result } = await this.$store.dispatch(
        "queryDeclareByShopIds",
        params
      );

      // 判断是否所有 declareDataList 都为空
      const allEmpty = result.every(
        (v) =>
          Array.isArray(v.declareDataList) && v.declareDataList.length === 0
      );

      if (allEmpty) {
        this.$message.warning("该门店无申报单");
        this.resetData();
        return;
      }

      // 当前逻辑继续执行
      let imgList = result.flatMap((v) => {
        return v.declareDataList.map((item) => ({
          ...item,
          shopId: v.shopId, // 将 shopId 注入到每个 declareDataList 元素中
        }));
      });

      this.srcList = unique(imgList.flat());
      this.declareSn = (this.srcList[0] && this.srcList[0].declareSn) || "";
      this.selectedImg = 0;
      this.detailsSalesVolumeList();
      this.runTemplateAllByDeclareSn();
    },
  async queryStoreTagList() { //获取门店已经打的标签
      let params = {
        shopIds:this.selectedShopsList.map((v) => v.shopId),
      };
      await this.$store.dispatch("queryStoreTagList", params).then((res) => {
        if (res.code == 0) {
        if (res.result && Array.isArray(res.result) && res.result.length > 0) {
  // 如果 res.result 有数据，则进行匹配赋值
  res.result.forEach(resItem => {
    const matchedLabel = this.labelGather.find(
      label => label.itemValue === resItem.fieldType
    );

    if (matchedLabel) {
      matchedLabel.tagNameList = resItem.tagNameList || [];
    }
  });
} else {
  // 如果 res.result 无数据，清空所有 labelGather 的 tagNameList
  this.labelGather.forEach(label => {
    label.tagNameList = [];
  });
}
        }
      });
    },
    // 获取小票和ocr结果
    async detailsSalesVolumeList() {
      let params = {
        declareSn: this.declareSn,
        declareVersion: "old",
      };
      await this.$store
        .dispatch("detailsSalesVolumeList", params)
        .then((res) => {
          this.ocrResultList = res.result.ocrResultList;
          this.declareImg = res.result.declareImg;
          this.detailsSalesVolume = res.result;
          this.resetImg();
          // this.runTemplateAllByDeclareSn();
        });
    },
    // 获取标签匹配
    async runTemplateAllByDeclareSn() {
      //  let declareSnList = this.srcList.map(item => item.declareSn);
      let params = {
        declareSnList: this.srcList.map((item) => item.declareSn),
        fieldType: this.fieldType,
      };
      let imgList = "";
      await this.$store
        .dispatch("runTemplateAllByDeclareSn", params)
        .then((res) => {
          // this.tagId = "";
          // this.labelList = res.result;
          let tagId = "";
          let tagBasicInfoId = "";
          const result = res.result || [];
          if (result.length) {
            tagId = result[0].runTemplateAllModelList[0].tagId;
            tagBasicInfoId = result[0].tagBasicInfoId;
            imgList = this.findMatchingDeclareModelList(result) || result[0].runTemplateAllModelList[0].runTemplateDeclareModelList;
            // imgList =
            //   result[0].runTemplateAllModelList[0].runTemplateDeclareModelList;
            result.map((v) => {
              v.isExpanded = false;
            });
          }
          // 更新 labelGather 中对应 fieldType 的项的 labelList
          this.labelGather = this.labelGather.map((item) => ({
            ...item,
            optTagId:
              item.itemValue === this.fieldType
                ? // ? item.optTagId
                  // ? item.optTagId
                  // : tagId
                  // : item.optTagId
                  // ? item.optTagId
                  // : "",
                  item.optTagId || tagId
                : item.optTagId || "",
            optTagBasicInfoId:
              item.itemValue === this.fieldType
                ? // ? item.optTagBasicInfoId
                  // ? item.optTagBasicInfoId
                  // : tagBasicInfoId
                  // : item.optTagBasicInfoId
                  // ? item.optTagBasicInfoId
                  // : "",
                  item.optTagBasicInfoId || tagBasicInfoId
                : item.optTagBasicInfoId || "",
            labelList:
              item.itemValue === this.fieldType
                ? result
                : item.isShow
                ? item.labelList
                : [],
          }));
        });
      console.log(this.labelGather, "完成第二步", this.srcList);
      setTimeout(() => {
        if(imgList) {
           this.combinationImg(imgList);
        }
      }, 100);
    },
/**
 * 查找 labelGather 中具有有效 optTagId 的项，并在 result 中查找匹配的 tagId
 * 如果匹配成功，返回 runTemplateDeclareModelList 数据；否则返回 false
 */
findMatchingDeclareModelList(result) {
  let labelGather = this.labelGather;
  // 检查参数是否为数组
  if (!Array.isArray(labelGather) || !Array.isArray(result)) {
    return false;
  }

  // 遍历 labelGather 查找具有有效 optTagId 的项
  for (const item of labelGather) {
    const { optTagId } = item;

    // 跳过没有 optTagId 的项
    if (!optTagId) continue;

    // 遍历 result 查找 runTemplateAllModelList
    for (const resultItem of result) {
      const { runTemplateAllModelList } = resultItem;

      // 确保 runTemplateAllModelList 存在且是数组
      if (Array.isArray(runTemplateAllModelList)) {
        // 遍历 runTemplateAllModelList 查找 tagId 匹配项
        for (const model of runTemplateAllModelList) {
          if (model.tagId === optTagId) {
            // 返回匹配的 runTemplateDeclareModelList 数据
            return model.runTemplateDeclareModelList || false;
          }
        }
      }
    }
  }

  // 没有找到匹配项
  return false;
},
    changeTags(i, e) {
      console.log(i, e, "标签标签");
      // this.tagId = e.tagId;
      if (i.optTagId === e.tagId) {
        i.optTagId = "";
        i.optTagBasicInfoId = "";
      } else {
        i.optTagId = e.tagId;
        i.optTagBasicInfoId = e.tagBasicInfoId;
      }
      this.fieldType = i.itemValue
      this.combinationImg(e.runTemplateDeclareModelList);
    },
    combinationImg(arr) {  //增加图片角标
      if (
        !Array.isArray(this.labelGather) ||
        !Array.isArray(arr) ||
        !Array.isArray(this.srcList)
      ) {
        return;
      }

      console.log("原始 srcList:", JSON.parse(JSON.stringify(this.srcList)));

      for (const labelItem of this.labelGather) {
        for (const arrItem of arr) {
          if (labelItem.itemValue !== arrItem.fieldType) continue;

          const targetSrcItem = this.srcList.find(
            (item) => item.declareSn === arrItem.declareSn
          );
          if (!targetSrcItem) continue;

          if (labelItem.optTagId) {
            if (!Array.isArray(targetSrcItem.typeList)) {
              this.$set(targetSrcItem, "typeList", []);
            }

            const existsIndex = targetSrcItem.typeList.findIndex(
              (item) => item.fieldType === arrItem.fieldType
            );

            if (existsIndex > -1) {
              targetSrcItem.typeList.splice(existsIndex, 1, { ...arrItem });
            } else {
              targetSrcItem.typeList.push({ ...arrItem });
            }

            this.$set(targetSrcItem, "typeList", [...targetSrcItem.typeList]);
          } else {
            if (Array.isArray(targetSrcItem.typeList)) {
              targetSrcItem.typeList = targetSrcItem.typeList.filter(
                (item) => item.fieldType !== labelItem.itemValue
              );
              this.$set(targetSrcItem, "typeList", [...targetSrcItem.typeList]);
            }
          }
        }
      }

      // 使用深拷贝打印，确保看到的是最新状态
      console.log(
        "处理后的 srcList:",
        JSON.parse(JSON.stringify(this.srcList))
      );
      this.$nextTick(() => {
        this.getLabelMatchingResult();
      });
    },
    getLabelMatchingResult() { //处理申报信息标签匹配结果
      // 查找 srcList 中 declareSn 等于当前 declareSn 的项
      const matchedItem = this.srcList.find(
        (item) => item.declareSn === this.declareSn
      );
      console.log("matchedItem:", matchedItem);
      console.log("matchedItem.typeList:", matchedItem.typeList);
      console.log("is typeList array:", Array.isArray(matchedItem.typeList));
      if (!matchedItem || !Array.isArray(matchedItem.typeList)) {
        // 如果没有找到匹配项或 typeList 不存在/不是数组，清空 labelMatchingResult 并返回
        console.log(21212);
        this.labelMatchingResult = this.allMerchant;
        return;
      }

      // 遍历 labelMatchingResult，并尝试从 typeList 中找到匹配的 fieldType，注入 declareGoodsInfo
      this.labelMatchingResult = this.labelMatchingResult.map((labelItem) => {
        // 在 typeList 中查找 fieldType 相同的项
        const typeItem = matchedItem.typeList.find(
          (type) => type.fieldType === labelItem.itemValue
        );
        console.log(typeItem, 99999);
        // 如果找到对应项，则添加 declareGoodsInfo，否则保留原样（或设为 null）
        return {
          ...labelItem,
          declareGoodsInfo: typeItem ? typeItem.declareGoodsInfo : null,
        };
      });
  
      console.log("更新后的 labelMatchingResult:", this.labelMatchingResult);
      //遍历this.labelMatchingResult返回itemValue = "number"的declareGoodsInfo数据
      let nameList = ''
      let nameFide = []
    for (let i = 0; i < this.labelMatchingResult.length; i++) {
      const item = this.labelMatchingResult[i];
      if (item.itemValue === 'number') {
        item.declareGoodsInfo.map(info => {
          nameFide.push({
            fieldValue:info.goodsName
          })
        })
      }
    }
    nameList = {
            itemText:'商品名称',
            declareGoodsInfo:[...nameFide]
          }
     console.log(nameList,'lalalalla')  
     if (
  this.labelMatchingResult.length > 0 &&
  this.labelMatchingResult[0].itemText === '商品名称'
) {
  this.labelMatchingResult.shift(); // 删除第一个
}
     this.labelMatchingResult.unshift(nameList);   
    },
    // 获取标签组类型
    async queryAllTag() {
      //  let arr = [
      //   {itemText:'商品名称',list:[{fieldValue:'洁伶上帝视角撒娇大开杀戒',isCorrect:'对'},{fieldValue:'海龟',isCorrect:'错'}]},
      //   {itemText:'商品数量',list:[{fieldValue:'2',isCorrect:'对'},{fieldValue:'1',isCorrect:'错'}]}
      //  ]
      const { result } = await this.$store.dispatch(
        "tagCategoryInfoQueryPageList",
        {
          parentId: 1,
          level: 1,
          pageNo: 1,
          pageSize: 9999,
        }
      );
      this.tagGroupList = result.records;
    },
    //获取所属分类
    getAttributeIndex(id) {
      this.$store
        .dispatch("tagBasicInfoQueryTagListByCategoryId", {
          tagCategoryId: id,
        })
        .then((res) => {
          const data = res.result;
          // data.forEach(v => {
          //   v.attrId = v.tagCategoryId;
          //   v.categoryType = "tagDetail";
          //   v.categoryName = v.tagName;
          //   v.disabled = true;
          //   v.leaf = true;
          // });
          this.tagGroupListTwo = data;
        });
    },
    // 保存标签和门店
    async joinTagaddTagShops() {
      let params = {
        // tagId: this.tagId,
        // shopDataList: this.selectedShopsList,
        // fieldType: this.fieldType,
        shopDataList: this.selectedShopsList,
        tagDataList: this.generateFieldTagArray(),
      };
      await this.$store.dispatch("joinTagaddTagShops", params).then((res) => {
        if (res.code == "0") {
           this.$message({
            type: "success",
            message: "操作成功",
          });
          // this.queryStoreTagList()
         this.queryStoreShopListByStoreCode(this.selectedStoreList.storeCode,this.selectedStoreList.storeName)
        }
      });
    },
    committed() {
      console.log(this.selectedShopsList, "sadkjaskj", this.labelGather);
      this.generateFieldTagArray();
      if (!this.selectedShopsList.length) {
        this.$message.warning("请选择门店");
      } else if (!this.generateFieldTagArray().length) {
        this.$message.warning("请选择标签");
      } else {
        this.joinTagaddTagShops();
      }
    },
    saveData() {
      //let arr = []
      // 遍历this.labelGather 找到isShow为true的项 将itemValue push到 arr=[{fieldType:itemValue}]
      //然后遍历this.labelGather中的labelList 根据this.labelGather中的optTagBasicInfoId和labelList中tagBasicInfoId的匹配
      //然后相等就在遍历labelList中的runTemplateAllModelList
      //然后再用this.labelGather中的optTagId和runTemplateAllModelList中的tagId匹配 若相等 就push到 arr=[{fieldType:itemValue,tagBasicInfoId:tagBasicInfoId,tagId:tagId,tagName:tagName}]
      //最后返回arr
    },
    generateFieldTagArray() {
      const result = [];

      if (!Array.isArray(this.labelGather)) {
        return result;
      }

      for (const gatherItem of this.labelGather) {
        // 只处理 isShow 为 true 的项
        if (gatherItem.isShow !== true) continue;

        const { itemValue, optTagBasicInfoId, optTagId } = gatherItem;

        if (!Array.isArray(gatherItem.labelList)) continue;

        for (const labelItem of gatherItem.labelList) {
          // 判断 tagBasicInfoId 是否匹配
          if (labelItem.tagBasicInfoId !== optTagBasicInfoId) continue;

          if (!Array.isArray(labelItem.runTemplateAllModelList)) continue;

          for (const templateItem of labelItem.runTemplateAllModelList) {
            // 判断 tagId 是否匹配
            if (templateItem.tagId === optTagId) {
              result.push({
                fieldType: itemValue,
                tagBasicInfoId: labelItem.tagBasicInfoId,
                tagId: templateItem.tagId,
                tagName: templateItem.tagName,
              });
            }
          }
        }
      }
      console.log(result, "最终数据");
      return result;
    },
    callOff() {
      //取消模板选择
      // this.tagId = "";
      console.log(this.validOptTagIds, "dasdjj=晋级赛结束时间");
    },
    // 选择标签组
    changeTagCategory(e) {
      console.log(e, "dasdjj");
      this.tagGroupList.map((item) => {
        if (item.id == e) {
          this.ruleLableForm.tenantId = item.tenantId;
        }
      });
      this.getAttributeIndex(e);
    },
    // 模板弹框功能
    cancel(done) {
      this.resetRuleForm();

      this.dialogVisible = false;
    },
    typeChange(val) {
      if (val === "receiptDate") {
        this.placeholder = "例如：2020-12-01 19:00:00";
      } else if (val === "receiptSn") {
        this.placeholder = "输入一个示例小票号，例如：FBD202010512312345";
      } else if (val === "receiptDateStr" || val === "shopName") {
        this.placeholder = "输入一个示例时间戳，例如：20201212121212";
      }
      if (val == "receiptDate") {
        this.ruleForm.strDemo = "";
      }
      const foundItem = this.allMerchant.find(item => item.itemValue === val);
      if (foundItem) {
        this.regularMatchDesc = foundItem.regularMatchDesc;
      } else {
        this.regularMatchDesc = '';
      }
    },
    handleClose(tag) {
      this.ruleForm.pasLabels.splice(this.ruleForm.pasLabels.indexOf(tag), 1);
    },
    handleInputConfirm() {
      let inputValue = this.inputValue;
      if (inputValue) {
        this.ruleForm.pasLabels.push(inputValue);
        this.ruleForm.pasLabels = unique(this.ruleForm.pasLabels);
      }
      this.inputVisible = false;
      this.inputValue = "";
    },
    showInput() {
      this.inputVisible = true;
      this.$nextTick(() => {
        this.$refs.saveTagInput.$refs.input.focus();
      });
    },
    handleCloseLast(tag) {
      this.ruleForm.pasLabelsLast.splice(
        this.ruleForm.pasLabelsLast.indexOf(tag),
        1
      );
    },
    handleInputConfirmLast() {
      let inputValue = this.inputValueLast;
      if (inputValue) {
        this.ruleForm.pasLabelsLast.push(inputValue);
        this.ruleForm.pasLabelsLast = unique(this.ruleForm.pasLabelsLast);
      }
      this.inputVisibleLast = false;
      this.inputValueLast = "";
    },
    showInputLast() {
      this.inputVisibleLast = true;
      this.$nextTick(() => {
        this.$refs.saveTagInputLast.$refs.input.focus();
      });
    },
    handleRegAdd() {
      let key = this.regList[this.regList.length - 1].key;
      this.regList.push({ key: key + 1, value: "" });
    },
    handleRegDel(index) {
      this.regList.splice(index, 1);
    },
    handleCloseKey(tag) {
      this.ruleForm.keyRepeatList.splice(
        this.ruleForm.keyRepeatList.indexOf(tag),
        1
      );
    },
    handleInputConfirmKey() {
      let inputValue = this.inputValueKey;
      if (inputValue) {
        this.ruleForm.keyRepeatList.push(inputValue);
        this.ruleForm.keyRepeatList = unique(this.ruleForm.keyRepeatList);
      }
      this.inputVisibleKey = false;
      this.inputValueKey = "";
    },
    showInputKey() {
      this.inputVisibleKey = true;
      this.$nextTick(() => {
        this.$refs.saveTagInputKey.$refs.input.focus();
      });
    },
    uploadMainPicSucc(jsonData) {
      if (jsonData.code === 0) {
        this.ruleForm.templateImg = jsonData.result;
        this.uploadShow = false;
      }
    },
    beforeUpload(file) {
      const extension =
        file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() ===
          "jpg" ||
        file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() === "gif";
      const extension2 =
        file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() ===
        "jpeg";
      const extension3 =
        file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() === "png";
      const extension4 =
        file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() === "bmp";
      // file.size单位为b，除以1024得到kb
      //   const limitSize = file.size / 1024 <= 1020;
      if (!extension && !extension2 && !extension3 && !extension4) {
        this.$message({
          message: "上传模板只能是 jpg、jpeg、png、bmp格式!",
          type: "warning",
        });
      }
      //   if (!limitSize) {
      //     this.$message({
      //       message: "上传模板大小不能超过 1M!",
      //       type: "warning"
      //     });
      //   }
      return extension || extension2 || extension3 || extension4;
    },
    // 正在上传
    uploading() {
      this.isSaving = true;
      this.uploadShow = true;
    },
    handleRemove() {
      this.ruleForm.templateImg = "";
    },
    async submitForm() {
      const valid = await this.$refs.ruleForm.validate();
      const valid1 = await this.$refs.labelRuleForm.validate();
      if (valid && valid1) {
        let params = JSON.parse(JSON.stringify(this.ruleForm));
        if (this.ruleForm.templateType === "number") {
          params.regularExtractRule = this.regList
            .filter((item) => item.value)
            .map((item) => item.value)
            .join("|");
        }

        if (this.ruleForm.templateType === "receiptRepeat") {
          if (params.keyRepeatList.length) {
            params.keyRepeat = params.keyRepeatList.join(",");
          } else {
            params.keyRepeat = "";
          }
        } else {
          if (params.pasLabels.length) {
            params.keyPrefix = params.pasLabels.join(",");
          } else {
            params.keyPrefix = "";
          }
          if (params.pasLabelsLast.length) {
            params.keySuffix = params.pasLabelsLast.join(",");
          } else {
            params.keySuffix = "";
          }
        }
        this.sysReceiptOcrTemplateModel = params;
        this.addTemplateTag();
        // let name =
        //   this.type === "add"
        //     ? "sysReceiptOcrTemplateAdd"
        //     : "sysReceiptOcrTemplateEdit";

        // const { code } = await this.$store.dispatch(name, params);
        // if (code === "0") {
        //   // this.$message({
        //   //   type: "success",
        //   //   message: "操作成功"
        //   // });
        //   // this.dialogVisible = false;
        //   this.tagAdd();
        //   // this.resetRuleForm();
        // }
      }
      // if(valid1) {
      //   console.log(this.ruleLableForm,'lalalal')
      // }
    },
    async tagAdd() {
      const params = {
        tagId: this.ruleLableForm.id,
        dataDesc: this.ruleLableForm.dataDesc,
        dataColor: this.ruleLableForm.dataColor,
        frontViewName: this.ruleLableForm.frontViewName,
      };
      // Object.assign(params, JSON.parse(JSON.stringify(this.ruleFormTag)));
      const { code } = await this.$store.dispatch(
        "tagDataRangeConfigAdd",
        params
      );
      if (code === "0") {
        this.addTemplateTag();
      }
    },
    async addTemplateTag() {
      const params = {
        sysReceiptOcrTemplateModel: this.sysReceiptOcrTemplateModel,
        tagDataRangeConfigModel: {
          tagId: this.ruleLableForm.id,
          dataDesc: this.ruleLableForm.dataDesc,
          dataColor: this.ruleLableForm.dataColor,
          frontViewName: this.ruleLableForm.frontViewName,
          tenantId: this.ruleLableForm.tenantId,
        },
        declareSnList: this.srcList.map((item) => item.declareSn),
      };
      // Object.assign(params, JSON.parse(JSON.stringify(this.ruleFormTag)));
      const { code, result } = await this.$store.dispatch(
        "addTemplateTag",
        params
      );
      if (code === "0") {
        this.$message({
          type: "success",
          message: "操作成功",
        });
        this.tagJoinTemplateId = result.tagJoinTemplateId;
        this.tagPercentage = parseFloat((result.passRate * 100).toFixed(2));
        // this.dialogVisible = false;
        // this.runTemplateAllByDeclareSn();
        // this.resetRuleForm();
      } else {
        // this.resetRuleForm();
      }
    },
    async updateTemplateTagStatus() {
      const params = {
        tagJoinTemplateId: this.tagJoinTemplateId,
      };
      const { code } = await this.$store.dispatch(
        "updateTemplateTagStatus",
        params
      );
      if (code === "0") {
        this.$message({
          type: "success",
          message: "操作成功",
        });
        this.dialogVisible = false;
        this.runTemplateAllByDeclareSn();
        this.resetRuleForm();
      } else {
        this.resetRuleForm();
      }
    },
    resetRuleForm() {
      this.$refs.ruleForm.resetFields();
      this.$refs.labelRuleForm.resetFields();
      // this.ruleForm.id = "";
      this.ruleForm.keyWord = "";
      this.ruleForm.numIndex = "";
      this.ruleForm.rowSeq = "";
      this.ruleForm.relativePosition = "";
      this.ruleForm.minStrLength = "";
      this.ruleForm.maxStrLength = "";
      this.ruleForm.keyRepeatList = [];
      this.ruleForm.pasLabels = [];
      this.ruleForm.pasLabelsLast = [];
      this.showResult = false;
      // this.ocrResultList = [];
      this.ruleForm.prefixType = "notInclude";
      this.ruleForm.regularExtractRule = "";
      this.ruleForm.templateImg = "";
      this.ruleForm.upwardOffsetRange = undefined;
      this.ruleForm.downwardOffsetRange = undefined;
      this.regList = [{ key: 1, value: "" }];
      this.tagJoinTemplateId = "";
      this.tagPercentage = 0;
      this.$forceUpdate();
    },
    addConfiguration() {
      this.queryAllTag();
      this.dialogVisible = true;
    },
    resetData() {
      this.declareSn = "";
      this.selectedStoreList.shopName = ''
      this.labelGather = this.labelGatherOne;
      this.srcList = [];
      this.declareImg = "";
      this.ocrResultList = [];
      this.detailsSalesVolume = {};
      this.fieldType = this.labelGatherOne[0].itemValue
    },
  },
};
</script>

<style lang="scss">
.page-component__scroll {
  height: 100%;
}
.page-component__scroll .el-scrollbar__wrap {
  overflow-x: auto;
}
.elCascaderBox {
.el-cascader .el-input {
    cursor: pointer;
    width: 100%;
}
}

</style>
<style lang="scss" scoped>
.bg {
  background: #fff;
  box-shadow: 0px 1px 3px 0px rgba(0,0,0,0.05);
  border-radius: 16px 16px 16px 16px;
}
.temp-header {
  background: rgba(255, 255, 255, 1);
  color: #000;
  padding: 10px 20px 10px 0;
  font-size: 16px;
  user-select: none;
  display: flex;
  align-items: center;
  // justify-content: space-evenly;
  margin-bottom: 10px;
  border-radius: 8px;
}
.ocrResult {
  width: 350px;
  // height: 100vh;
}
.title {
  font-size: 18px;
  margin-bottom: 10px;
  &::before {
    display: inline-block;
    margin-right: 10px;
    content: "";
    width: 4px;
    height: 12px;
    background: #e50065;
    border-top-left-radius: 30px;
    border-bottom-right-radius: 30px;
  }
}
.titleRight {
  font-size: 18px;
  margin-bottom: 10px;
}
.declareSnImg {
  position: relative;
  width: 80px;
  height: 104px;
  margin: 0 10px 10px 0;
  cursor: pointer;
}
.declareElImg {
  width: 100%;
  height: 104px;
  border-radius: 6px;
}
.activeDeclareSnImg {
  border: 3px solid #e50065;
  height: 114px;
  // padding: 5px 5px 1px;
  box-sizing: border-box;
  background: #efacce;
  border-radius: 6px;
}
.declareSnImgNumTypeBox {
  position: absolute;
  top: 0;
  display: flex;
  flex-direction: column;
  background: #daffe0;
  width: 100%;
  max-height: 100%;
  overflow-y: auto;
  gap: 3px;
  font-weight: 500;
  font-size: 11px;
  color: #007b15;
  border-radius: 6px;
  padding: 3px 0;
  box-sizing: border-box;
  opacity: 0.8;
  .declareSnImgNumType {
    display: flex;
    justify-content: space-around;
  }
}
.crb-content {
  height: 680px;
  position: relative;
  .tableHeight {
    position: absolute;
    width: 100%;
  }
}
.hmicon {
  color: #e50065;
  font-size: 18px;
}
.left {
  position: relative;
  // min-width: 400px;
  width: 350px;
  // max-width: 380px;
  height: 600px;
  background-color: #fff;
  padding: 20px;
  float: left;
  overflow: hidden;
  border: 1px solid #ddd;
  .img {
    position: absolute;
    top: 5px;
    left: 7px;
    max-width: 400px;
    height: auto;
    cursor: move;
  }
}
.ocr {
  background: rgba(255, 249, 252, 1);
  border: 1px solid rgba(229, 0, 101, 1);
  border-radius: 6px;
  padding: 5px;
}
.leftBox {
  background: rgba(255, 249, 252, 1);
  border-radius: 6px;
  padding: 10px;
  box-sizing: border-box;
}
.leftStoreBox {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.storeBox {
  background: #fff;
  padding: 20px 10px;
  border-radius: 10px;
  .storeItem {
    display: flex;
    justify-content: space-between;
    align-items: center;
    box-sizing: border-box;
    padding-right: 5px;
    cursor: pointer;
    .storeName {
      display: flex;
      // align-items: center;
      font-size: 14px;
      font-weight: bold;
      color: #606266;
      .iconStore {
        color: #6b7280;
        margin-right: 5px;
      }
    }
  }
  .shopBox {
    display: flex;
    flex-direction: column;
    margin-left: 20px;
    gap: 10px;
    .shopItem {
      display: flex;
      justify-content: space-between;
      align-items: center;
      background: #f3f4f6;
      padding: 10px 5px;
      box-sizing: border-box;
      border-radius: 5px;
      font-size: 14px;
      cursor: pointer;
    }
    .shopItem:hover {
      background: #fedeec;
      // color: #fff;
    }
  }
  .checkTrue {
    color: #e60e6d !important;
    font-size: 16px;
  }
  .checkFalse {
    flex-shrink: 0;
    width: 11px;
    height: 11px;
    border-radius: 50%;
    border: 1px solid #606266;
  }
}
.basicInformation {
  // border-top: 1px solid #dcdfe6;
  margin: 0 auto;
  font-size: 15px;
  color: #000;
}
.shopGoodsNumBox {
  border: 1px solid #dcdfe6;
  border-radius: 10px;
  box-sizing: border-box;
  .shopGoodsNumTitle {
    display: flex;
    flex-wrap: wrap;
    padding: 10px 20px;
    background: #f3f5f8;
    border-radius: 10px 10px 0 0;
    .rightTagsBox {
      flex: 1;
      font-size: 10px;
      display: flex;
      gap: 10px;
      flex-wrap: wrap;
      margin-left: 20px;
     .rightTags {
      padding: 3px;
      color: #222222;
      background: #C4CBD8;
      border-radius: 5px;
      // border: 1px solid #0081E5;
     }
    }
  }
  .shopLabelBox {
    padding: 10px 20px;
    .shopLabelTitle {
      margin-bottom: 5px;
      font-size: 16px;
    }
    .shopLabelContent {
      display: flex;
      gap: 10px;
      flex-wrap: wrap;
      .shopLabel {
        padding: 5px 10px;
        background: #eeeeee;
        border-radius: 5px;
        font-size: 12px;
        color: #505050;
        cursor: pointer;
      }
    }
  }
  .rowBox {
    display: flex;
    align-items: center;
    // justify-content: space-around;
    padding: 10px;
    font-size: 12px;
    color: #222222;
    gap: 30px;
  }
  .rowBox div:nth-child(1) {
    width: 120px;
    text-align: left;
  }
  .rowBox div:nth-child(2) {
    width: 240px;
    text-align: left;
  }
  .rowBox:nth-child(odd) {
    background: #f7f7f7;
  }
}
.bottomFiexd {
  position: absolute;
  // width: 50%;
  box-sizing: border-box;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  // left: 0;
  // background: pink;
  padding: 10px 0;
  display: flex;
  gap: 20px;
  .confirmFiexd {
    width: 100px;
    text-align: center;
    padding: 10px 0;
    color: #fff;
    border-radius: 4px;
    background: #ff5777;
    cursor: pointer;
  }
  .cancelFiexd {
    width: 100px;
    text-align: center;
    padding: 10px 0;
    color: #333;
    border-radius: 4px;
    background: #ccc;
    cursor: pointer;
  }
}
.input-number-wrap {
  .el-input-number {
    width: 120px;
  }
  /deep/ .el-input {
    width: 100%;
  }
}
.mx8 {
  margin: 0 8px;
}
.priview {
  position: relative;
  width: 375px;
  height: 408px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  img {
    width: 100%;
    height: 100%;
  }
  .opreat-wrapper {
    transition: opacity 0.2s linear;
    position: absolute;
    opacity: 0;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    border-radius: 6px;
  }

  &:hover {
    .opreat-wrapper {
      opacity: 1;
    }
  }
}
.green-text {
  color: #42b983; // 绿色
}

.red-text {
  color: #ff4d4d; // 红色
}
.activeSelect {
  background: #fedeec !important;
  color: #e82179 !important;
}
/deep/ .el-tabs__header {
  margin: 0;
}
.store-name-text {
  display: inline-block;
  max-width: 240px; // 可根据实际布局调整
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.custom-scrollbar {
  // min-height: 200px;
  max-height: 400px;
  overflow-y: auto;
  scrollbar-width: thin; /* Firefox */
  scrollbar-color: #dddade transparent; /* Firefox */
}

/* WebKit browsers (Chrome, Edge, Safari) */
.custom-scrollbar::-webkit-scrollbar {
  width: 10px;
}

.custom-scrollbar::-webkit-scrollbar-track {
  background: transparent; /* Remove the track background */
}

.custom-scrollbar::-webkit-scrollbar-thumb {
  background: #dddade;
  border-radius: 5px;
}

.custom-scrollbar::-webkit-scrollbar-thumb:hover {
  background: #555;
}

.custom-scrollbar::-webkit-scrollbar-button {
  display: none; /* Hide the scroll arrows */
}
.unfoldPackBox {
  padding-top: 10px;
  width: 100%;
  text-align: center;
  font-size: 14px;
  cursor: pointer;
  // background: #f0f4f7;
}
.config-drawer {
  .drawer-content {
    width: 90%;
    margin: 0 auto;
  }
}
/deep/ .el-drawer__body {
  overflow-y: auto;
  max-height: calc(100vh - 60px);
  scrollbar-width: thin; /* Firefox */
  scrollbar-color: #dddade transparent; /* Firefox */
}
.truncate-text {
  white-space: nowrap; /* 禁止换行 */
  overflow: hidden; /* 隐藏溢出内容 */
  text-overflow: ellipsis; /* 添加省略号 */
  max-width: 70px; /* 可选：设置最大宽度 */
}
.cellDiv:nth-child(odd) {
  background: #f7f7f7;
}
.informationLabel {
  border: 1px solid #dcdfe6;
  border-radius: 10px;
  box-sizing: border-box;
  padding: 20px;
  font-size: 12px;
  height: 300px;
  // min-height:200px;
  // max-height:300px
  /* 横向滚动容器 */
.horizontal-scroll-container {
  display: block;
  white-space: nowrap; /* 禁止换行 */
  overflow-x: auto; /* 启用横向滚动 */
  -webkit-overflow-scrolling: touch; /* 在 iOS 上启用弹性滚动 */
  padding-bottom: 10px; /* 可选：给滚动条留点空间 */
}

/* 保持 cellWidth 内容块显示为 inline-block 并控制最小宽度 */
.cellWidth {
  display: inline-block;
  vertical-align: top;
  max-width: 120px; /* 可根据实际内容调整 */
  white-space: normal; /* 允许内部换行 */
}
  // .cellWidth {
  // // white-space: nowrap; /* 禁止换行 */
  // overflow: hidden; /* 隐藏溢出内容 */
  // text-overflow: ellipsis; /* 添加省略号 */
  // max-width: 120px; /* 可选：设置最大宽度 */
  // }
  .cellBox {
    min-height: 40px;
    max-height: 60px;
    // background: pink;
  }
}
.matchingResultBox {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 10px 20px;
  background: #e1f9ea;
  border-radius: 0px 0px 0px 0px;
  font-size: 12px;
}
</style>
